import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4556e6cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "what-makes-us" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("What Makes Us "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "Aardvark")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " Professionals, enthusiasts and innovators! ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TripleBlock = _resolveComponent("TripleBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_TripleBlock, {
        group: 'makes-us',
        blocksData: _ctx.AboutData.whatMakeUs
      }, null, 8, ["blocksData"])
    ])
  ]))
}